export default () => ({
  languageList: [],
  status: undefined,
  key: undefined,
  selectedLanguage: null,
});
